$(document).ready(function () {
  if ($(".js-multiselect-icon").length) {
    $(".js-multiselect-icon").multiselect({
      noneSelectedText: "Select clubs",
      selectedText: "# selected",
      multiple: true,
    });
  }

  $(document).on(
    "click",
    '.multiselect-icon__menu input[type="checkbox"]',
    function () {
      var checkedItem = $(".multiselect-icon__menu input:checked");
      var checkedItemLength = checkedItem.length;

      if (checkedItemLength == 1) {
        var text = checkedItem.siblings("span").text();

        $(".js-multiselect-icon").multiselect({
          selectedText: text,
        });
      } else {
        $(".js-multiselect-icon").multiselect({
          selectedText: "# selected",
        });
      }
    }
  );

  if ($(".touchevents").length) {
    $(window).on("orientationchange", function () {
      $(".js-multiselect-icon").multiselect("close");
    });
  } else {
    $(window).on("resize", function () {
      $(".js-multiselect-icon").multiselect("close");
    });
  }
});

$(window).on("load", function () {
  if ($(".js-multiselect-icon").length) {
    let mltslWidth = $(".form-item-wrap--multiselect-icon").outerWidth();

    $(".ui-multiselect-menu").outerWidth(mltslWidth);

    $(".js-multiselect-icon")
      .find("option.multiselect-icon__item")
      .each(function (i) {
        let img = $(this).attr("data-img");
        $(".ui-multiselect-checkboxes li label")
          .eq(i)
          .append('<img class="mltsl-img" src="' + img + '"/>');
      });

    $(".multiselect-icon__item")
      .closest(".ui-multiselect-menu")
      .addClass("multiselect-icon__menu");
  }
});
